export const getDefaultValues = (landingDetails) => ({
  LandPageLandPageCategoryID: landingDetails?.LandPageLandPageCategoryID || '',
  LandPageTitle: landingDetails?.LandPageTitle || '',
  LandPageSubTitle: landingDetails?.LandPageSubTitle || '',
  LandPageDescription: landingDetails?.LandPageDescription || '',
  LandPageImageDesktop: landingDetails?.LandPageImageDesktop || '',
  LandPageImageMobileV: landingDetails?.LandPageImageMobileV || '',
  LandPageImageMobileH: landingDetails?.LandPageImageMobileH || '',
  LandPageLink: landingDetails?.LandPageLink || '',
  LandPageLinkText: landingDetails?.LandPageLinkText || '',
  LandPageIsShowTextInfo: landingDetails?.LandPageIsShowTextInfo || '',
  LandPageIsShowButton: landingDetails?.LandPageIsShowButton || '',
});
